"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SocialLinks_1 = __importDefault(require("../SocialLinks"));
var Copyright_1 = __importDefault(require("../../Copyright"));
var TermsPolicyLinks_1 = __importDefault(require("../TermsPolicyLinks"));
var HomeFooter = function () {
    return (react_1.default.createElement("div", { className: "footer-bottom-container" },
        react_1.default.createElement("div", { className: "footer-bottom" },
            react_1.default.createElement(SocialLinks_1.default, null),
            react_1.default.createElement("div", { className: "center-copy" },
                react_1.default.createElement(Copyright_1.default, null)),
            react_1.default.createElement("div", { className: "terms-and-cond" },
                react_1.default.createElement(TermsPolicyLinks_1.default, null)),
            react_1.default.createElement("div", { className: "mobile-copyright" },
                react_1.default.createElement(Copyright_1.default, null)))));
};
exports.default = HomeFooter;
